import React from 'react';
import Button from '../components/Button/Button';
import { Meta } from '../styled components/Typography';

interface ListViewPaginationProps {
  page: number;
  pagesCount: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

/* Previous/next paging over the (filtered) bookings of the list view */
function ListViewPagination({
  page,
  pagesCount,
  totalCount,
  onPageChange
}: ListViewPaginationProps) {
  if (pagesCount <= 1) return null;
  return (
    <div tw="flex items-center justify-end space-x-8 mt-8" data-test-list-view-pagination>
      <Meta>
        {i18n('Page {page} of {pages} ({total} items)', {
          page,
          pages: pagesCount,
          total: totalCount
        })}
      </Meta>
      <Button
        contentType="icon"
        icon="navigate-before"
        size="small"
        color="default"
        variant="outlined"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        aria-label={i18n('Previous page')}
        dataAttributes={{ 'data-test-list-view-previous-page': true }}
      />
      <Button
        contentType="icon"
        icon="navigate-next"
        size="small"
        color="default"
        variant="outlined"
        disabled={page >= pagesCount}
        onClick={() => onPageChange(page + 1)}
        aria-label={i18n('Next page')}
        dataAttributes={{ 'data-test-list-view-next-page': true }}
      />
    </div>
  );
}

export default ListViewPagination;
